import CanvasImage from "@/components/konva/CanvasImage.tsx";
import {useDungeon} from "@/encounter/dungeon/DungeonHooks.ts";
import {mapImageTransform} from "@/dungeons/geometry/Coordinates.ts";


export default function DungeonMapLayer() {
    const {dungeon, dungeonSettings} = useDungeon();

    const level = dungeon.levels.find(level => level.id === dungeonSettings.levelId);
    if (!level) return <></>;
    const transform = mapImageTransform(level.geometry);
    return <CanvasImage
        listening={false}
        image={level.map.image}
        {...transform}
        width={level.map.image.width}
        height={level.map.image.height}
    />
}
